/* eslint-disable react-hooks/exhaustive-deps */
import styles from "./MapBox.module.css";
import SearchBar from "../../Components/SearchBar";
import ResultBox from "../../Components/ResultBox";

import { store } from "../../Context/Store";
import { Redirect } from 'react-router-dom'
import { useMapEvents } from "react-leaflet";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import { CheckLogin, Logout, ReverseGeocode } from "../../API/Pins";
import { memo, useContext, useEffect, useState } from "react";

const MapBox = (props) => {
  const [mapBox, setMapBox] = useState();
  const [CheckAuth, setCheckAuth] = useState(true);
  const [ShowResultBox, setShowResultBox] = useState(false);

  const context = useContext(store);
  const { state, dispatch } = context;

  useEffect(() => {
    const CheckAuth = async () => {
      try {
        const res = await CheckLogin();
        dispatch({ type: "SET_ROLE", role: res?.data?.role })
        setCheckAuth(true);
      } catch (error) {
        setCheckAuth(false);
      };
    };

    CheckAuth();
  }, [])

  useEffect(() => {
    if (state.latlng.length && state.selectedAddress) {
      setShowResultBox(true);
      if (mapBox) {
        // mapBox.flyTo([...state.latlng], 17, {
        //   animate: true,
        //   duration: 1.5,
        //   noStartMove: true,
        // });
      }
    } else {
      setShowResultBox(false);
    }
  }, [state.latlng, state.selectedAddress]);

  useEffect(() => {
    if (state.addAddressMode) {
      setShowResultBox(true);
    }
  }, [state.addAddressMode]);

  useEffect(() => {
    if (state.flyToCity.length) {
      mapBox.flyTo(state.flyToCity, 12, {
        animate: true,
        duration: 1.5,
        noStartMove: true,
      });
    }
  }, [state.flyToCity])

  useEffect(() => {
    if (state.flyToLocation.length) {
      mapBox.flyTo(state.flyToLocation, 15, {
        animate: true,
        duration: 1.5,
        noStartMove: true,
      });
    }
  }, [state.flyToLocation])

  const handleResetMap = () => {
    if (mapBox) {
      const coords = state.flyToCity.length ? state.flyToCity : [35.6892, 51.389]
      mapBox.flyTo(coords, 12, {
        animate: true,
        duration: 2,
        noStartMove: true,
      });
      dispatch({ type: "RESET_MAP" });
    }
  };

  const handleLogoutUser = async () => {
    try {
      await Logout();
      setCheckAuth(false);
    } catch (error) {
      console.dir(error)
    };
  };

  if (!CheckAuth) {
    return <Redirect to="/login" />
  }

  const HandleReverseGeocode = async (latitude, longitude) => {
    try {
      dispatch({ type: "NOT_FOUND_ADDRESS", state: false })
      dispatch({ type: "LOADING_ADDRESS", state: true })
      const res = await ReverseGeocode({ latitude, longitude });
      dispatch({ type: "LOADING_ADDRESS", state: false })
      dispatch({ type: "SET_ADDRESS", address: res?.data[0]?.address || res?.data?.address, item: res?.data[0] || res?.data })
    } catch (error) {
      dispatch({ type: "LOADING_ADDRESS", state: false })
      dispatch({ type: "NOT_FOUND_ADDRESS", state: true })
      console.log(error)
    };
  }

  const EventsOnMap = () => {
    useMapEvents({
      click(e) { // click on map
        if (state.addAddressMode) {
          dispatch({ type: "ADD_LOCATION", location: [e.latlng.lat, e.latlng.lng] })
        } else if (state.editMode) {
          dispatch({ type: "CHANGE_LOCATION", location: [e.latlng.lat, e.latlng.lng] })
        } else {
          dispatch({ type: "SET_LATLNG", latlng: [e.latlng.lat, e.latlng.lng] })
          HandleReverseGeocode(e.latlng.lat, e.latlng.lng);
        }
      },
    });
    return false;
  }

  return (
    <div className={styles.appWrapper}>
      <div className={styles.mapWrapper}>

        <SearchBar handleResetMap={handleResetMap} />

        <ResultBox show={ShowResultBox} />

        <div className="flex gap-3 items-center absolute top-5 left-16">
          <div onClick={handleLogoutUser} className={styles.button}> LogOut </div>
          {state?.role === "Admin" && <div onClick={() => props.history.push("/admin/users")} className={styles.button}> Admin Dashboard </div>}
        </div>

        <MapContainer
          minZoom={8}
          whenCreated={(map) => setMapBox(map)}
          center={{ lat: 35.6892, lng: 51.389 }}
          zoom={13}
          scrollWheelZoom={true}
          style={{ height: "100%", width: "100%" }}
        >
          <EventsOnMap />
          <TileLayer
            attribution='Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>'
            // url="https://api.mapbox.com/styles/v1/habib-/ckopqctic2ifr17o8i7j3lkvx/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiaGFiaWItIiwiYSI6ImNrb3BtNHA0ZzAxdXoycHA2OGhjcHNpN2sifQ.q8XSVpyVn0YWfXNeHUCIWg"
            url="https://tile.optime-infra.ir/tile/{z}/{x}/{y}.png"
          />
          {state.latlng.length || (state.addAddressMode && state.addLocation.length) ?
            <Marker
              position={state.editMode ? state.editedLocation : state.addAddressMode ? state.addLocation : state.latlng}
              draggable={state.editMode || state.addAddressMode}
              // icon={divIcon({
              //   className: "optime-custom-marker",
              //   html: OptimeMarker(),
              // })}
              eventHandlers={{
                dragend: (e) => {
                  if (state.editMode) {
                    dispatch({ type: "CHANGE_LOCATION", location: [e.target._latlng.lat, e.target._latlng.lng] })
                  }
                  if (state.addAddressMode) {
                    dispatch({ type: "ADD_LOCATION", location: [e.target._latlng.lat, e.target._latlng.lng] })
                  }
                },
              }}
            />
            : null}
        </MapContainer>
      </div>
    </div>
  );
};

export default memo(MapBox);
